
import { Box, Button, Stack, Typography } from "@mui/material";

import type { WidgetProps } from "./types";

export function ContentCard({ widget }: WidgetProps<"content_card">) {
    const { title, body, href, cta } = widget.props;

    return (
        <Box
            sx={{
                p: 3,
                border: 1,
                borderColor: "divider",
                borderRadius: "10px",
                bgcolor: "background.paper",
            }}
        >
            <Stack spacing={1.5}>
                <Typography variant="h5">{title}</Typography>
                {body && (
                    <Typography variant="body2" color="text.secondary">
                        {body}
                    </Typography>
                )}
                {href && cta && (
                    <Box>
                        <Button
                            variant="contained"
                            color="secondary"
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                        >
                            {cta}
                        </Button>
                    </Box>
                )}
            </Stack>
        </Box>
    );
}
